module.exports = __webpack_public_path__ + "static/media/supportDocument.272ac8ff.svg";